module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_7005.92b2fa90.png";